module.exports = __webpack_public_path__ + "static/media/ball.36fe388b.svg";